import { render, staticRenderFns } from "./KpiRemarks.vue?vue&type=template&id=42bb06c1&scoped=true&"
import script from "./KpiRemarks.vue?vue&type=script&lang=ts&"
export * from "./KpiRemarks.vue?vue&type=script&lang=ts&"
import style0 from "./KpiRemarks.vue?vue&type=style&index=0&id=42bb06c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bb06c1",
  null
  
)

export default component.exports